/** @jsx jsx */
import { jsx, Flex } from 'theme-ui'
import { Link as GatsbyLink } from 'gatsby'
import { useBreakpoint } from '../../utils/useWindowWidth'
import MobileNavigationMenu from './MobileNavigationMenu'
import DesktopNavigationMenu from './DesktopNavigationMenu'
import { useAuth } from '../../utils/useAuth'
import LogoHeader from './LogoHeader'
import { graphql, useStaticQuery } from 'gatsby'

export const HEADER_NAV = graphql`
  query headerSection {
    allContentfulHeaderSection {
      nodes {
        parentNav {
          id
          title
          navLinks {
            id
            title
            slug
          }
        }
      }
    }
  }
`

const NavigationHeader = () => {
  const { allContentfulHeaderSection } = useStaticQuery(HEADER_NAV)
  const navList = allContentfulHeaderSection?.nodes[0]?.parentNav
  const breakpoint = useBreakpoint()
  const { user } = useAuth()
  const userInitials = user
    ? `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`
    : ''
  return (
    <LogoHeader>
      <GatsbyLink
        to="/app/brand-studio-events"
        data-automation-id="register-live-event-link"
        sx={{
          textDecoration: 'none',
          cursor: 'pointer',
          width: ['auto', 'auto', 300],
          backgroundColor: 'citron',
          boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.75)',
          padding: ['8px', '8px 16px', '12px 16px'],
          minHeight: '44px',
          color: 'black',
          fontSize: ['14px', '16px'],
          textAlign: 'center',
          lineHeight: 1,
          margin: ['0px 20px', 0, '0 0 0 160px'],
          ':hover': { backgroundColor: 'citronHover' },
        }}
      >
        Register for a Live Event
      </GatsbyLink>
      <Flex>
        {breakpoint === 'mobile' || breakpoint === 'tablet' ? (
          <MobileNavigationMenu userInitials={userInitials} navList={navList} />
        ) : (
          <DesktopNavigationMenu
            navList={navList}
            userInitials={userInitials}
          />
        )}
      </Flex>
    </LogoHeader>
  )
}

export default NavigationHeader
